import { Component, OnInit } from '@angular/core';
import { AdminService } from '../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DrilldownResponse, IProduct, IFamily } from '../_models/drilldown';
import { isNull } from 'util';
import { Log } from 'ng2-logger';
import { ToastsManager } from 'ng2-toastr';
import { AppService } from '../app.service';
import { DrilldownService } from '../_services/drilldown.service';
import {ACLFeature} from '../_models/acl-feature';
import {Permissions} from '../_services/permissions';
import Util from '../util';

const log = Log.create('Drilldown');

@Component({
  moduleId: module.id,
  selector: 'edit-drilldown',
  styleUrls: ['drilldown.less'],
  templateUrl: 'drilldown.component.html'

})
export class DrilldownComponent implements OnInit {
  // The current parent id in use
  private parentId: number;
  canWriteDrivers = false;
  canWriteModules = false;

  // Are we looking at modules or drivers
  type: string;
  showArchived = false;

  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private appService: AppService,
              private drilldownService: DrilldownService,
              private permissions: Permissions,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {
    this.appService.tagBreadcrumbs.breadcrumbs = [];
    // A fixed root node
    const rootPath = {
      id: null,
      name: 'Top level'
    };

    // Observe changes to the route and fetch new families/products
    this.route.params.subscribe(params => {

      this.type = params['type'];
      this.parentId = params['parentId'] == null || params['parentId'] === 'null' ? null : params['parentId'];
      this.showArchived = Util.toBoolean(params['showArchived']);

      log.d('params', params);

      this.admin.drilldown(this.type, this.parentId, this.showArchived).subscribe((response: DrilldownResponse) => {
        const families = isNull(response.families) ? [] : this.transformFamilies(response.families);
        this.drilldownService.setFamilies(families);

        log.d('families', families);

        this.drilldownService.setProducts(isNull(response.products) ? [] : this.transformProducts(response.products));

        // Set request family type
        this.appService.headerData.type = this.type;

        let pathLength: number = 0;

        if (null != response.path) {
          pathLength = response.path.length;
        }

        if (pathLength > 0) {
          this.appService.headerData.title = response.path[pathLength - 1].name;
        } else {
          this.appService.headerData.title = 'Drilldown ' + this.type;
        }

        if (null != response.path) {
          this.appService.headerData.path = response.path;
          this.appService.headerData.path.unshift(rootPath);
        }
      });
    });

    this.permissions.hasFeature(ACLFeature.WRITE_DRIVERS)
      .subscribe((success) => {
          this.canWriteDrivers = success;
    });

    this.permissions.hasFeature(ACLFeature.WRITE_MODULES)
      .subscribe((success) => {
          this.canWriteModules = success;
    });
  }

  /**
   * Transfrom Products for use in table
   * @param products
   * @returns Array<IProduct>
   */
  private transformProducts(products: Array<IProduct>) {
    return products
      .sort((a, b) => a.name < b.name ? -1 : a.name === b.name ? 0 : 1 )
      .sort((a, b) => a.sortOrder < b.sortOrder ? -1 : a.sortOrder === b.sortOrder ? 0 : 1);
  }

  /**
   * Transform Families for use in table
   * @param families
   * @returns Array<IFamily>
   */
  private transformFamilies(families: Array<IFamily>) {
    return families
      .sort((a, b) => a.name < b.name ? -1 : a.name === b.name ? 0 : 1)
      .sort((a, b) => a.sortOrder < b.sortOrder ? -1 : a.sortOrder === b.sortOrder ? 0 : 1);

  }
}



// WEBPACK FOOTER //
// ./src/app/drilldown/drilldown.component.ts